export const SYSTEM_IDENTIFIER_AU_VENDORID = 'http://ns.electronichealth.net.au/id/hi/vendorid/1.0';
